import { Command } from 'commander';
import ora from 'ora';
import prompts from 'prompts';
import { WorkflowManager } from '../core/workflow-manager';
import { logger } from '../utils/logger';

export function createInitCommand(): Command {
  const command = new Command('init');

  command
    .description('Initialize workflow system in current project')
    .option('-f, --force', 'Force overwrite existing workflow configuration')
    .option('-y, --yes', 'Skip confirmation prompts')
    .option('--no-ai', 'Disable AI features')
    .option('--claude', 'Enable Claude Code integration (auto-detected if .claude exists)')
    .option('--no-hooks', 'Disable Claude Code hooks configuration')
    .action(async (options) => {
      try {
        const manager = new WorkflowManager({
          enableAI: options.ai !== false
        });

        // Check if already initialized
        if (await manager.isInitialized() && !options.force) {
          if (!options.yes) {
            const { confirm } = await prompts({
              type: 'confirm',
              name: 'confirm',
              message: 'Workflow system already initialized. Overwrite?',
              initial: false
            });

            if (!confirm) {
              logger.info('Initialization cancelled');
              return;
            }
          }
        }

        const spinner = ora('Initializing workflow system...').start();

        try {
          // Set environment variable if Claude integration is requested
          if (options.claude) {
            process.env.CLAUDE_CODE = 'true';
          }
          if (options.hooks === false) {
            process.env.WORKFLOW_NO_HOOKS = 'true';
          }

          await manager.initialize(options.force);
          spinner.succeed('Workflow system initialized successfully!');

          logger.info('');
          logger.info('Next steps:');
          logger.info('  1. Run "workflow run init" to initialize your project');
          logger.info('  2. Run "workflow run todo" to manage tasks');
          logger.info('  3. Run "workflow sync" to sync with your TODO files');
          
          // Add Claude-specific instructions if integrated
          if (process.env.CLAUDE_CODE || await manager.isClaudeIntegrated()) {
            logger.info('');
            logger.info('Claude Code integration:');
            logger.info('  - Use /task command to manage tasks');
            logger.info('  - Use /kb command to search knowledge base');
            logger.info('  - Use /workflow-init to reinitialize');
          }
          
          logger.info('');
          logger.info('For more help, run "workflow --help"');
        } catch (error) {
          spinner.fail('Failed to initialize workflow system');
          throw error;
        }
      } catch (error: any) {
        logger.error('Initialization failed:', error.message);
        if (process.env.DEBUG) {
          console.error(error);
        }
        process.exit(1);
      }
    });

  return command;
}